import React, { PureComponent } from "react";
import "./Header.scss";
import logo from "../../assets/logo.png";
import Classnames from "classnames";

interface Props {
  scrolledPastIntro: boolean;
}

class Header extends PureComponent<Props> {
  render() {
    const { scrolledPastIntro } = this.props;

    return (
      <div className={Classnames("Header", { scrolledPastIntro })}>
        <a href="https://www.thetrevorproject.org/" target="_blank">
          <img src={logo} alt="logo" className="logo" />
        </a>
        <div className="title">
          <span>National Survey on LGBTQ Youth Mental Health 2021</span>
        </div>
      </div>
    );
  }
}

export default Header;
